<template>
  <el-dialog
      v-el-drag-dialog
      :visible.sync="dialogVisible"
      :close-on-click-modal="false"
      :title="vehicle.pkId > 0 ? '编辑' : '新建'"
      width="1000px"
      @close="$reset('form')">
    <el-form
        ref="form"
        v-loading="contentLoading"
        :model="vehicle"
        :rules="ruleValidate"
        class="form"
        label-width="80px">
      <el-row>
        <el-col v-if="vehicle.pkId > 0" :span="12">
          <el-form-item label="载具编号" prop="vehicleNo">
            <el-input v-model="vehicle.vehicleNo" disabled placeholder="请输入载具编号"/>
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="载具名称" prop="vehicleName">
            <el-input v-model="vehicle.vehicleName" placeholder="请输入载具名称"/>
          </el-form-item>
        </el-col>
        <el-col :span="12" style="height:43px">
          <el-form-item label="长度单位" prop="cubicUnitName">
            <el-input v-model="vehicle.cubicUnitName" placeholder="请选择长度单位" readonly>
              <el-button slot="append" @click="$refs.selectCubicUnit.open()">选择</el-button>
            </el-input>
            <unit-select ref="selectCubicUnit" @select="selectCubicUnit"/>
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="长度" prop="length">
            <el-input v-model="vehicle.length" placeholder="请输入长度"/>
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="宽度" prop="width">
            <el-input v-model="vehicle.width" placeholder="请输入宽度"/>
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="限长" prop="lengthLimit">
            <el-input v-model="vehicle.lengthLimit" placeholder="请输入限长"/>
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="限宽" prop="widthLimit">
            <el-input v-model="vehicle.widthLimit" placeholder="请输入限宽"/>
          </el-form-item>
        </el-col>
        <el-col :span="12" style="height:43px">
          <el-form-item label="载重单位" prop="loadUnitName">
            <el-input v-model="vehicle.loadUnitName" placeholder="请选择载重单位" readonly>
              <el-button slot="append" @click="$refs.selectLoadUnit.open()">选择</el-button>
            </el-input>
            <unit-select ref="selectLoadUnit" @select="selectLoadUnit"/>
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="载重" prop="load">
            <el-input v-model="vehicle.load" placeholder="请输入载重"/>
          </el-form-item>
        </el-col>
      </el-row>
    </el-form>
    <span slot="footer">
      <el-button @click="dialogVisible = false">取消</el-button>
      <el-button :loading="submitLoading" type="primary" @click="handleSubmit">确定</el-button>
    </span>
  </el-dialog>
</template>

<script>
  import UnitSelect from "@/views/information/Unit/UnitSelect";
  export default {
    name: "VehicleEdit",
    components: { UnitSelect },
    data() {
      return {
        dialogVisible: false,
        submitLoading: false,
        contentLoading: false,
        vehicle: {
          pkId: 0,
          vehicleNo: "",
          vehicleName: "",
          width: "",
          length: "",
          lengthLimit: "",
          widthLimit: "",
          cubicUnitId: 0,
          cubicUnitName: "",
          load: "",
          loadUnitId: 0,
          loadUnitName: "",
        },
        ruleValidate: {
          vehicleNo: { required: true, message: "请输入载具编号", trigger: "blur" },
          vehicleName: { required: true, message: "请输入载具名称", trigger: "blur" },
        },
      };
    },
    methods: {
      open(id) {
        this.vehicle.pkId = id;
        this.dialogVisible = true;
        if (id > 0) {
          this.getData();
        }
      },

      // 根据载具id查询详细信息
      getData() {
        this.contentLoading = true;
        this.$http
          .get("basic", `vehicles/${this.vehicle.pkId}`)
          .then((resp) => {
            if (resp.success) {
              this.vehicle = Object.assign(this.vehicle, resp.data);
              this.contentLoading = false;
            }
          })
          .catch(() => {
            this.contentLoading = false;
          });
      },

      // 编辑、新建
      handleSubmit() {
        this.$refs.form.validate((valid) => {
          if (valid) {
            this.submitLoading = true;
            this.$http
              .save("basic", "vehicles", this.vehicle)
              .then((resp) => {
                this.submitLoading = false;
                if (resp.success) {
                  if (this.vehicle.pkId > 0) {
                    this.$emit("save-success");
                    this.$message.success("编辑成功");
                  } else {
                    this.$emit("save-success");
                    this.$message.success("添加成功");
                  }
                  this.dialogVisible = false;
                }
              })
              .catch(() => {
                this.submitLoading = false;
              });
          }
        });
      },

      selectCubicUnit(row) {
        this.vehicle.cubicUnitId = row.pkId;
        this.vehicle.cubicUnitName = row.unitName;
      },

      selectLoadUnit(row) {
        this.vehicle.loadUnitId = row.pkId;
        this.vehicle.loadUnitName = row.unitName;
      },
    },
  };
</script>
